module.exports = __webpack_public_path__ + "Golfresort.jpg?ede620927bdcac37de38e6c86f2e0710";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Golfresort.jpg
// module id = 64
// module chunks = 0